import CompensationRequestByChequeInputGroup from './CompensationRequestByChequeInputGroup'

export default CompensationRequestByChequeInputGroup
